import React from "react"
import { Link } from "gatsby"

import { Text } from "../../Text/Text"


interface OwnProps {
  navLinks: [{ name: string, link: string }]
  setActiveSubNav: () => void
  title: string
}

type FooterLinksProps = OwnProps

export const NavItem: React.FC<FooterLinksProps> = ({
  navLinks,
  setActiveSubNav,
  title,
}) => {
  return (
    <div className="group nav-item py-5 border-solid border-b-[1px] border-warm-grey first:border-none lg:ml-5 lg:py-0 lg:border-none">
      <div className="relative text-navy group-[.active]:after:rotate-180 after:content-['⌄'] after:text-[25px] after:absolute after:bottom-0 after:right-0 lg:after:hidden" onClick={(event) => setActiveSubNav(event.currentTarget.parentNode)}>
        <div className="font-martel-sans leading-[140%] text-[16px] uppercase font-semibold cursor-pointer md:text-[14px] hover:text-sage">{title}</div>
      </div>
      <ul className={`sub-nav bg-white z-10 lg:absolute lg:pb-6 lg:pr-6 hidden group-[.active]:block`} >
        {navLinks?.map((item, index) => {
          return (
            <li className="mt-6 ml-6" key={index}>
              <Link className="text-navy" to={item.link}>
                <div className="font-martel-sans leading-[140%] text-[16px] uppercase font-semibold md:text-[14px] hover:text-sage">{item.name}</div>
              </Link>
            </li>
          )
        })}   
      </ul>
    </div>
  )
}
